import apiClient from '@/services/AccountClient'

const state = () => ({
  integratorList: [],
  integratorListLoaded: false
})

const getters = {
  integratorOptions: (state) => {
    return state.integratorList.map(integrator => ({
      name: integrator,
      value: integrator
    }))
  },
  integratorListLoaded: (state) => {
    return state.integratorListLoaded
  }
}

const actions = {
  loadIntegratorList ({ commit }) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/integrators/types'
    )
      .then(({ payload }) => {
        commit('setIntegratorList', payload)
        commit('setIntegratorListLoaded')
      })
  }
}

const mutations = {
  setIntegratorList (state, currencyList) {
    state.integratorList = currencyList
  },
  setIntegratorListLoaded (state) {
    state.integratorListLoaded = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
